<div>
  <h1>Знаки и разметка правил дорожного движения 2026</h1>
</div>

<div>
  <h2>Знаки</h2>
</div>
<div>
  <ul class="list_znaki">
    <ng-container *ngFor="let category_znaki of this.ZnakiService.znaki; let  i = index">
      <li>
        <a [routerLink]="['/', 'znaki-'+category_znaki.category.url]">
          <div class="sb-num">
            <img width="60px" src="{{category_znaki.category.img_icon}}">
          </div>
          <div>
            {{ category_znaki.category.name }}
          </div>
        </a>
      </li>
    </ng-container>
  </ul>
</div>

<div>
  <h2>Горизонтальная и вертикальная разметки</h2>
</div>
<div>
  <ul class="list_category">
    <ng-container *ngFor="let category_razmetka of this.RazmetkaService.razmetka; let  i = index">
      <li>
        <a [routerLink]="['/', 'razmetka-'+category_razmetka.category.url]">
          <div class="sb-num">
            <i [class]="{'gorizontalnaya': category_razmetka.category.url == 'gorizontalnaya',  'vertikalnaya': category_razmetka.category.url == 'vertikalnaya',}"></i>
          </div>
          <div>
            {{ category_razmetka.category.name }}
          </div>
        </a>
      </li>
    </ng-container>
  </ul>
</div>
